import { h } from 'preact';
import { ProductCard } from './ProductCard';
import { SkeletonCard } from './SkeletonCard';
import { Banner } from '../banner/Banner';
import styles from './ProductGrid.module.scss';
import { useColourwayStorefrontData } from '../../utils/useColourwayStorefrontData';
export function ProductGrid({ products, loading, layout, banners = [], skeletonCount = 8, }) {
    const { colourwayData, observeCard } = useColourwayStorefrontData(products, {
        enabled: !loading,
    });
    if (loading) {
        return (h("div", { class: styles.productGridFour }, Array.from({ length: skeletonCount }, (_, i) => (h(SkeletonCard, { key: i })))));
    }
    let layoutClass = '';
    switch (layout.cardLayout) {
        case 'gridTwo':
            layoutClass = styles.productGridTwo;
            break;
        case 'gridFour':
            layoutClass = styles.productGridFour;
            break;
        case 'list':
            layoutClass = styles.productList;
            break;
        default:
            layoutClass = styles.productGridFour;
    }
    const needsFilterAdjustment = layout.filterLayout === 'filterSide' &&
        (layout.cardLayout === 'gridFour' || layout.cardLayout === 'gridTwo');
    const finalClassName = needsFilterAdjustment
        ? `${layoutClass} ${styles.productGridFourWithSideFilter}`
        : layoutClass;
    const sortedBanners = [...banners].sort((a, b) => a.position - b.position);
    const bannerMap = new Map();
    sortedBanners.forEach(banner => {
        if (!bannerMap.has(banner.position)) {
            bannerMap.set(banner.position, []);
        }
        bannerMap.get(banner.position).push(banner);
    });
    const maxBannerPosition = sortedBanners.length > 0 ? Math.max(...sortedBanners.map(b => b.position)) : -1;
    const totalIterations = Math.max(products.length + sortedBanners.length, maxBannerPosition + 1);
    const items = [];
    let productIndex = 0;
    for (let i = 0; i < totalIterations; i++) {
        if (bannerMap.has(i)) {
            const bannersAtPosition = bannerMap.get(i);
            bannersAtPosition.forEach((banner, idx) => {
                items.push(h(Banner, { key: `banner-${i}-${idx}`, banner: banner }));
            });
        }
        if (productIndex < products.length) {
            const product = products[productIndex];
            const pid = String(product.id);
            // Keep the first grid row fully rendered for the initial viewport/LCP.
            // Later cards may be skipped by the browser until they approach the viewport.
            const canDeferRendering = productIndex >= 4 && layout.cardLayout !== 'list';
            items.push(h("div", { key: product.id, ref: el => observeCard(pid, el), class: `${styles.cardObserveRoot}${canDeferRendering ? ` ${styles.deferredCard}` : ''}`, "data-product-id": pid },
                h(ProductCard, { product: product, layout: layout.cardLayout, imagePriority: productIndex === 0, colourwayStorefrontData: colourwayData })));
            productIndex++;
        }
    }
    return (h("div", { class: finalClassName, "data-layout": layout.cardLayout, "data-filter-layout": layout.filterLayout }, items));
}
